/// <reference types="@angular/localize" />

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import 'hammerjs';
import {AppConfigService} from './app/config/app-config.service';
import {LogService} from './app/services/LogService';

const DYNATRACE_SCRIPT_ID = 'dynatrace-script';

const initializeDynatrace = () => {
	if (typeof document === 'undefined' || !environment || !environment.dynatraceUrl) {
		return;
	}

	if (document.getElementById(DYNATRACE_SCRIPT_ID)) {
		return;
	}

	const script = document.createElement('script');
	script.id = DYNATRACE_SCRIPT_ID;
	script.src = environment.dynatraceUrl;
	script.type = 'text/javascript';
	script.async = true;
	document.head.appendChild(script);
};

initializeDynatrace();

platformBrowserDynamic().bootstrapModule(AppModule)
	.then(ref => {
		const configService = ref.injector.get(AppConfigService);
		if ('serviceWorker' in navigator && environment.production) {
			navigator.serviceWorker.register('./ngsw-worker.js');
		}
	})
	.catch(err => {
		const tempLogService = new LogService();
		tempLogService.debug('Bootstrap failed', err);
	});
